module.exports = __webpack_public_path__ + "static/media/aisur.af1bb9c3.jpg";